import {Model} from './model';

export class InvoiceStateLog implements Model {
  public invoiceStateLogId: number;
  invoiceStateId: number;
  invoiceId: number;
  userId: number;
  reason: string;
  changed: Date;

  static copy(oldObj: InvoiceStateLog): InvoiceStateLog {
    const newObj = new InvoiceStateLog();
    newObj.invoiceStateLogId = oldObj.invoiceStateLogId;
    newObj.invoiceStateId = oldObj.invoiceStateId;
    newObj.invoiceId = oldObj.invoiceId;
    newObj.userId = oldObj.userId;
    newObj.reason = oldObj.reason;
    newObj.changed = oldObj.changed;
    return newObj;
  }

  getPrimaryKey(): number {
    return this.invoiceStateLogId;
  }

  isNew(): boolean {
    return isNaN(this.invoiceStateId);
  }

  clone(): InvoiceStateLog {
    return InvoiceStateLog.copy(this);
  }
}
